import { Modal, Pagination, Spin } from "antd"
import { displayMessage } from "../../services/helper"
import { useContext, useEffect, useState } from "react"
import GeneralContext from "../../context/GeneralContext/GeneralContext"
import api from "../../services/api"
import { DateTime } from "luxon"
import { LoadingOutlined } from "@ant-design/icons"


export default function MangosHistory(props) {
    const { setShowLoading, show_loading, windowHeight, } = useContext(GeneralContext)

    const { handleOnCloseModalHistoryMangos, currentPatient, isModalMangosHistoryVisible }= props

    const [mangoHistory, setMangoHistory] = useState([])
    const [totalCount, setTotalCount] = useState([])

    useEffect(()=>{getMangosHistory()},[])

    const getMangosHistory = async (page = 1) => {
        setShowLoading(true)
        try {
            const mangos_history =  await api.patient.listMangos({id: currentPatient.id, page})
            setMangoHistory(mangos_history?.data?.data)
            setTotalCount(mangos_history?.data?.count)
        } catch (error) {
            console.log(error)            
        } finally {
            setShowLoading(false)
        }
    }

    function HistoricCard({ info }) {
        const send_date = DateTime.fromISO(info?.createdAt).toFormat("dd/MM/yyyy - HH:mm");
    
        return (
            <div style={{ display: 'flex', backgroundColor: "#f0f0f0", flexDirection: 'column', minHeight: '150px', padding: '10px', borderRadius: '8px', gap: 5}}>
                <div style={{display: 'flex', flex:1, justifyContent: 'center', fontWeight: 'bold'}}>
                    {`${info?.operation_type} ${info?.amount} ${displayMessage("MANGOS")}`}
                </div>
                <div style={{paddingTop: 2, paddingBottom: 2}}>
                    <p style={{fontWeight: 'bold', margin:0}}>
                        {displayMessage("DESCRIPTION") + ": "}
                    </p>
                     {info?.description}
                </div>
                <div style={{display: 'flex', flex:1, justifyContent: 'space-between'}}>
                    <p style={{fontWeight: 'bold'}}>
                        {displayMessage("SYNC_DATE") + ": "} 
                    </p>
                    {send_date}
                </div>
            </div>
        );
    }
    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('HISTORY_MANGOS_TITLE', [currentPatient?.first_name, currentPatient?.last_name])} </div>}
            visible={isModalMangosHistoryVisible}
            onCancel={() => handleOnCloseModalHistoryMangos()}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ height: windowHeight * 0.9, display: 'flex', flexDirection: 'column'}}
        >
            {
                !show_loading ?
                    <div style={{display: 'flex', flexDirection: 'column', gap: 5, height: '100%', overflow: 'auto'}}>
                        {
                            mangoHistory?.map(e => (
                                <HistoricCard key={e.id} info={e} />
                            ))
                        }
                    </div>
                :
                    <div style={{display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                        <Spin indicator={<LoadingOutlined spin/>} size='large' />
                    </div>
            }
            <Pagination defaultCurrent={1} total={totalCount} style={{paddingTop: '10px'}} onChange={(e)=>getMangosHistory(e)}/>
        </Modal>
    )
}